import React, { useState } from "react";
import "./Header.css";
import { useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "../firebase";
import { useAuth } from "../Login/AuthContext";

const Header = () => {
  const navigate = useNavigate();
  const { user, loading } = useAuth();

  const [menuOpen, setMenuOpen] = useState(false);

  const [hasNewModules, setHasNewModules] = useState(() => {
    if (typeof window === "undefined") return false;
    const stored = window.localStorage.getItem("hasNewModules");
    return stored === null ? true : stored === "true";
  });

  const handleHomeClick = () => {
    if (typeof window !== "undefined") window.location.href = "/";
  };

  const handleContactClick =() =>{
      if (typeof window !== "undefined") window.location.href = "/contact";
  
  }
  const handleModulesClick = () => {
    setHasNewModules(false);
    if (typeof window !== "undefined") {
      window.localStorage.setItem("hasNewModules", "false");
      window.location.href = "/modules";
    }
  };

  const handleToolsClick = () => {
    if (typeof window !== "undefined") window.location.href = "";
  };

  const handleAuthClick = async () => {
    if (!user) {
      navigate("/login");
      return;
    }
    try {
      await signOut(auth);
      navigate("/", { replace: true });
    } catch (e) {
      console.error("Logout failed:", e);
    }
  };

  return (
    <header className="header" style={{ margin: "20px" }}>
      <div
        className="logo"
        onClick={handleHomeClick}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") handleHomeClick();
        }}
        style={{ cursor: "pointer" }}
      >
        <div className="logo-mark">
          <svg className="logo-icon" viewBox="0 0 60 100" aria-hidden="true">
            <path
              d="
                M30 10
                C10 10, 10 40, 30 50
                C50 60, 50 90, 30 90
                C10 90, 10 60, 30 50
                C50 40, 50 10, 30 10
              "
              fill="none"
              stroke="white"
              strokeWidth="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <span className="logo-text">GILDARC</span>
      </div>

      <div className="header-right">
        <nav className={`nav-links ${menuOpen ? "active" : ""}`}>
          <button className="nav-button" onClick={handleHomeClick}>
            Home
          </button>

          <button
            className={`nav-button ${hasNewModules ? "new-dot" : ""}`}
            onClick={handleModulesClick}
          >
            Modules
          </button>

          <button className="nav-button" onClick={handleToolsClick}>
            Tools
          </button>
   <button className="nav-button" onClick={handleContactClick}>
            Contact
          </button>
          {/*}

          <button
            onClick={handleAuthClick}
            disabled={loading}
            className="
              px-4 py-2
              rounded-lg
              border border-amber-300/40
              bg-gradient-to-b from-amber-100 to-amber-200
              text-amber-900
              text-sm font-semibold
              transition
              hover:from-amber-200 hover:to-amber-300
              hover:border-amber-400/60
              active:translate-y-px
              focus:outline-none
              focus:ring-2 focus:ring-amber-400/30
              disabled:opacity-60
            "
          >
            {loading ? "…" : user ? "Log out" : "Log in"}
          </button>
        */}
        </nav>

        <button
          className={`hamburger ${menuOpen ? "active" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

      </div>
    </header>
  );
};

export default Header;
